module.exports = __webpack_public_path__ + "img/23_63.ccd5e5dd.png";